module.exports = __webpack_public_path__ + "img/user-manager.c4a275a3.svg";